module.exports = __webpack_public_path__ + "img/XO.c775c78f.svg";